export default function parseQueryString(string) {
    if(string.indexOf('?') === 0) {
        string = string.substr(1, string.length);
    }

    var query = {};

    var parts = string.split('&');
    for(var i = 0, l = parts.length; i < l; ++i) {
        var [key, value] = parts[i].split('=');

        query[decodeURIComponent(key)] = decodeURIComponent(value);
    }

    return query;
}